import NewMain from '@/components/renewal/NewMain'
import UserDataDeletion from '@/components/UserDataDeletion'
import Vue from 'vue'
import Router from 'vue-router'
import AASA from '../../apple-app-site-association'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: NewMain,
      meta: {
        title: '그레이드'
      }
    },
    // {
    //   path: '/eng',
    //   name: 'IntroductionEng',
    //   component: IntroductionEng
    // },
    // {
    //   path: '/kor',
    //   name: 'IntroductionKorWhite',
    //   component: IntroductionKorWhite
    // },
    // {
    //   path: '/black',
    //   name: 'IntroductionKor',
    //   component: IntroductionKor
    // },
    // {
    //   path: '/white',
    //   name: 'IntroductionKorWhite',
    //   component: IntroductionKorWhite
    // },
    {
      path: '/userdatadeletion',
      name: 'UserDataDeletion',
      component: UserDataDeletion
    },
    {
      path: '/apple-app-site-association',
      name: 'AASA',
      component: AASA
    }
  ]
})

// router.afterEach((to, from) => {
//   console.log(to, from)
//   Vue.nextTick(() => {
//     document.title = '그레이드'
//   })
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js